import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Product Tabs
 */
@Component
export class PageNavigation extends ThemeComponent {
    @Ref floatingNavigation!: HTMLDivElement;

    protected currentScrollTop: number = 0;

    protected floatingNavigationBounds: HeaderBounds = {
        top: 0,
        bottom: 0
    };

    init() {
        // eslint-disable-next-line no-console
        console.log('element', this.floatingNavigation);

        window.addEventListener('scroll', this.onScroll.bind(this), false);

        this.createObserver();
    }

    protected createObserver() {

        const observer = new IntersectionObserver((entries, observer) => {
            this.floatingNavigationBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.floatingNavigation);
    }


    onScroll() {
        // eslint-disable-next-line no-console
        console.log('on scroll');

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 140) {
            this.floatingNavigation.classList.add('fixed-navigation');
        } else {
            this.floatingNavigation.classList.remove('fixed-navigation');
        }

        this.currentScrollTop = scrollTop;
    }

}
